import React, { Component } from "react"
import { connect } from 'react-redux'

import {
    getSearchDirectoryInfoAction, getAllOrgUnitsAction,
} from '../../redux/actions/MasterAction'

import {
    updateMR_DetailAction,
} from '../../redux/actions/MRAction'

import {
    updateEvaluationModalAction,
} from '../../redux/actions/MRAction'

import {
    setInputAction,
} from '../../redux/actions/ModalEmployeeAction'

import { msg } from '../Notifications/MsgBox';
import utilityHelper from "../../helpers/helperUtil"

import { CenterFocusStrong, FormatAlignJustifySharp, HorizontalSplit, VerticalAlignCenter } from "@material-ui/icons";
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'
import {MessageText} from '../../configs';
import {Information } from "../core"
class SelectTypeWorkModal extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            ...props,
            q_empCode:'',
            q_empName:'',
            q_position:'',
            q_positionabbr:'',
            q_departmentCode:'',
            employeeSearchPIS:[],
            page: 0,
            rowsPerPage: 5,
            totalRecord:0,
            po_contract_no:"",
            work_type_flag:"use_bot",
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handlePoChange = this.handlePoChange.bind(this)  
        this.handlerSelectWorkType = this.handlerSelectWorkType.bind(this)      
        this.handleInTimeChange = this.handleInTimeChange.bind(this)
    }

    componentDidMount() {
        //his.props.getAllOrgUnits()
    }

    handleChange(event) {
        const { name, value } = event.target
       
        this.props.setInput(name, value);
        this.setState({
            [name]: value
        })
      }

    handleClick(event, newPage) {

        console.log("SearchEmployeeModal.handleClick()");
        const { ModalEmployee } = this.props;

        let q_empCode = ModalEmployee.q_empCode;
        let q_empName = ModalEmployee.q_empName;
        let q_position = ModalEmployee.q_position;
        let q_positionabbr = ModalEmployee.q_positionabbr;
        let q_departmentCode = ModalEmployee.q_departmentCode;
        let q_departmentName = ModalEmployee.q_departmentName;
        let q_departmentABBR = ModalEmployee.q_departmentABBR;

        let q_secondmentFlag = 0
        let allq = (q_empCode == null ? '' : q_empCode) + (q_empName == null ? '' : q_empName) + (q_position == null ? '' : q_position) 
        + (q_positionabbr == null ? '' : q_positionabbr) + (q_departmentCode == null ? '': q_departmentCode) + (q_departmentName == null ? '' : q_departmentName) + (q_departmentABBR == null ? '': q_departmentABBR);
        
        if (ModalEmployee.key_table === "T_MR_DETAIL" && (ModalEmployee.key_empCode === "approver_code" || ModalEmployee.key_empCode === "receiver_code")){
            q_secondmentFlag = 1;
        }

        if (allq.length < 2) {
            msg.error('กรุณาระบุเงื่อนไขในการค้นหาอย่างน้อย 2 ตัวอักษร')
            return
        }

        let { page, rowsPerPage } = this.state;
        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }

        this.props.getSearchDirectoryInfo(q_empCode, q_empName, q_position, q_positionabbr ,q_secondmentFlag, q_departmentCode, q_departmentName, q_departmentABBR, page * rowsPerPage, rowsPerPage ).then((response) => {
            if (response.data != null && response.data.length > 0) {
                console.log("response")
                console.log(response)
                this.setState({
                    employeeSearchPIS: response.data,
                    totalRecord: response.data[0].totalRow,
                    page: page,
                    rowsPerPage: rowsPerPage
                })
            }

            if (!response.data) {
                msg.error("ไม่พบข้อมูล")
                return
            }
        })
    }


    chooseItem(item) {

        const { ModalEmployee } = this.props;

        let { key_table, key_empCode, key_empName } = ModalEmployee;
        if (item != null) {
            console.log("chooseItem");
            console.log("employeeId: " + item.employeeId)
            console.log("employeeNameTH: " + item.employeeNameTH)

            console.log("key_empCode: " + key_empCode)
            console.log("key_empName: " + key_empName)

            if (key_table === 'T_MR_DETAIL') {
                this.props.updateMR_Detail(item.employeeId, key_empCode);
                this.props.updateMR_Detail(item.iname + " " + item.employeeNameTH, key_empName);
            }
            else if (key_table === 'T_MR_VENDOR') {

                this.props.updateEvaluationModal({
                    ...this.props.evaluationModal,
                    [key_empCode]: item.employeeId,
                    [key_empName]: item.iname + " " + item.employeeNameTH,
                });
            }
            else if (key_table === 'M_USER' || key_table === 'T_GR_DETAIL') {

                if (window.onUserSearchEmployeeSelected) {
                    window.onUserSearchEmployeeSelected(
                        key_table,
                        item.employeeId,
                        item.employeeNameTH,
                        item

                    )
                }
            }
            else {
                if (window.onSearchEmployeeSelected) {
                    window.onSearchEmployeeSelected(
                        key_table,
                        item.employeeId,
                        item.employeeNameTH,
                        item

                    )
                }
            }

            if (this.props.onSelected) {
                this.props.onSelected(item)
            }
        }
        this.setState({ employeeSearchPIS: null, totalRecord : 0 , rowsPerPage : 5})

    }

    setOrg_Unit() {
     
        const { org_unit } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(org_unit, "unitcode", "unitabbr", "unitcode")
        result.splice(0, 0, {"label":'- เลือกทั้งหมด -', "value":''})

        return result
    }

    async handleChangePage(event, newPage) {
        await this.setState({
            page: newPage
        })
        this.handleClick(event, newPage)
    }

    async handleChangeRowsPerPage(event) {
        await this.setState({
            rowsPerPage: event.target.value,
            page: 0
        })
        this.handleClick()
    }

    handlerSelectWorkType(){
 
            console.log("handlerSelectWorkType" ,this.props.handlerSelectWorkType);     
              if(this.props.handlerSelectWorkType){
            console.log("handlerSelectWorkType");    
            this.props.clearSearchDirectoryInfo();
            this.props.clearModal();
           this.props.handlerSelectWorkType(this.state.work_type_flag)
        }     
    }

    handlePoChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    handleInTimeChange(event) {
        this.handleChange(event);
    }

    render() {
        
        
        //const { q_empCode, q_empName } = this.state;
        const { employeeSearchPIS,work_type_flag } = this.state
        const { ModalEmployee } = this.props;
        let q_empCode = (ModalEmployee.q_empCode ? ModalEmployee.q_empCode : "");
        let q_empName = (ModalEmployee.q_empName ? ModalEmployee.q_empName : "");
        let q_position = (ModalEmployee.q_position ? ModalEmployee.q_position : "");
        let q_positionabbr = (ModalEmployee.q_positionabbr ? ModalEmployee.q_positionabbr : "");
        let q_departmentCode = (ModalEmployee.q_departmentCode ? ModalEmployee.q_departmentCode : "");
        let q_departmentName = (ModalEmployee.q_departmentName ? ModalEmployee.q_departmentName : "");
        let q_departmentABBR = (ModalEmployee.q_departmentABBR ? ModalEmployee.q_departmentABBR : "");

        console.log("employeeSearchPIS")
        console.log(employeeSearchPIS)
        // console.log("ModalEmployee")
        // console.log(ModalEmployee)

        return (
           
            <div className="modal fade sp-modal rrs-modal"  id="selectTypeWorkModal" tabIndex={-1} role="dialog" aria-labelledby="SelectTypeWorkModal" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document" style={{maxWidth:1040}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="selectTypeWorkModalLabel">ระบุข้อมูลลักษณะงาน</h5>
                            <input type="hidden" id="MR_DETAIL_Field_key"/>
                            <input type="hidden" id="MR_DETAIL_Field_val"/>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.chooseItem(null)}>
                                <span aria-hidden="true">×</span>
                            </button>
                          
                        </div>
                        <div className="modal-body rrs-container">
                    <div className="rrs-detail2">
                            <div className="rrs-form-group-search">
                                {/* <label htmlFor="search-purchase-num" className="rrs-form-group-search-label">Purchase / Contract Number</label> */}
                                <div className="row justify-content-center mx-0">

                                    {/*new  */}
                                    <div className="col-md-10"> 

                                       <div className="col-12 d-md-flex-left align-items-start flex-wrap px-0 rrs-fine-box-bb">
                                         <div className="col-1 rrs-information" >   {/*  </div> style={{alignContent:HorizontalAlignCenter}}> */}
                                      <Information width={670}>ใช้สำหรับการตรวจรับงานที่มีลักษณะดังนี้
                                      <ul>
                                        <li>คีย์ข้อมูลการตรวจรับงานด้วย Contract No. โดย Service line มี 1 account assignment ในการสร้าง PO No. 32*</li>
                                        <li>คีย์ข้อมูลการตรวจรัลบงานด้วย PO No. 31* หรือ 32* โดยมีงบประมาณรองรับ</li>
                                        </ul>
                                                 
                                      </Information> 
                                           </div>
                                        <div className="col-11" style={{alignContent:VerticalAlignCenter}}>
                                        
                                            <label htmlFor= "work_type_flag" className={`radiocontainer rrs-fine-label clickable font-radio`}>
                                                กรอกข้อมูลบันทึกรายงานการประชุมการตรวจรับ (MOM) และข้อมูล GR/IR/MR สำหรับ Run Bot ในระบบ RRS อัตโนมัติ
                                                <input
                                                    id="work_type_flag"
                                                    type="radio"
                                                    name="work_type_flag"
                                                    defaultValue="use_bot"
                                                    checked={work_type_flag === "use_bot"}
                                                    onChange={this.handleInTimeChange} 
                                                    disabled={false}                                
                                                    />
                                                <span className="checkmark" style={{top:'15px'}}/>
                                            </label>
                                        </div>
                                    </div>
                                        <div className="col-12 d-md-flex-left align-items-start flex-wrap px-0 rrs-fine-box-bb">
                                        <div className="col-1 rrs-information" >   {/*  </div> style={{alignContent:HorizontalAlignCenter}}> */}
                                      <Information width={670}>ใช้สำหรับการตรวจรับงานที่มีลักษณะ ดังนี้
                                      <ul>
                                        <li>การทำ Goods Return /Services Return</li>
                                        <li>การเพิ่มรายละเอียด Alternative</li>
                                        <li>Payee/Individual Payee</li>
                                        <li>งาน IR ที่มี Down Payment</li> 
                                        <li>งานแบบ Planned Cost ในขั้นตอนการสร้างข้อมูล IR</li>
                                        <li>Service line ที่เป็น Multiple account assignment</li> 
                                        <li>Credit Memo, Subsequence Debit, Subsequence Credit,Cancellation</li>
                                        </ul>
                                        <br/>
                                        <br></br>
                                       <strong>หมายเหตุ</strong> หากดำเนินการยกเลิก GR หรือแก้ไขรหัส EMA โปรดแจ้งหน่วยงานจัดหาให้ดำเนินการแก้ไขใน SAP ต่อไป        
                                      </Information> 
                                           </div>
                                            <div className="col-11">
                                                <label className="radiocontainer rrs-fine-label clickable font-radio" >
                                                    กรอกข้อมูลบันทึกรายงานการประชุมการตรวจรับ (MOM) ในระบบ RRS เท่านั้นโดยหน่วยงานจัดหาจะบันทึก GR/IR ในระบบ SAP
                                                    <input
                                                        type="radio"
                                                        name="work_type_flag"
                                                        defaultValue="not_bot"
                                                        checked={work_type_flag == "not_bot"}
                                                        onChange={this.handleInTimeChange} 
                                                        
                                                    />
                                                    <span className="checkmark" style={{top:'15px'}} />
                                                </label>
                                            </div>
                                    </div>
                
                                    </div>
                                    {/* new */}

                                    <div className="col-md-8">
                                        <div className="col-12 sp-header-button-panel2 justify-content-center">
                                            <a href="#" className="sp-btn-icon btn-ok" data-toggle="collapse" data-target="#rrsTab2" aria-expanded="false" aria-controls="rrsTab2"
                                              onClick={() =>{this.handlerSelectWorkType()}} >
                                                <i className="icon btn-order-check-green" />
                                                <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_OK}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                        </div>
                    
                </div>
            </div>                        
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux,MasterRedux, ModalEmployeeRedux} = state
    return {
    //   employeeSearchPIS: MasterRedux.employeeSearchPIS,
      ModalEmployee: ModalEmployeeRedux,
      evaluationModal: MainRedux.evaluationModal,
      org_unit: MasterRedux.org_unit,

    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      getSearchDirectoryInfo:(employeeCode,employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit) => dispatch(getSearchDirectoryInfoAction(employeeCode,employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit)),
      updateMR_Detail: (data, fieldName) => dispatch(updateMR_DetailAction(data, fieldName)),
      updateEvaluationModal: (data, fieldName) => dispatch(updateEvaluationModalAction(data, fieldName)),
      setInput: (input_name, input_value) => dispatch(setInputAction(input_name, input_value)),
      getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
      clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
      clearModal: () => dispatch(clearModalAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SelectTypeWorkModal)